import { LOGIN, LOGOUT } from "../actions/types";

const INITIAL_STATE = {
  authenticated: "",
  errorMessage: "",
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN:
      return { ...state, authenticated: action.payload.token };
    case LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
};
